import axios from 'axios';
import ProjectWithMembers from '@/domain/project/project-with-members.entity';
import ProjectPersist from '@/domain/project/project-persist.entity';
import snackbarService from '@/shared/snackbar/snackbar.service';

export default class ProjectService {
  static saveProject(project: any) {
    if (project.id) {
      return this.updateProject(project);
    }
    return this.createProject(project);
  }

  static createProject(project: ProjectPersist) {
    return axios
      .post('/project-api/projects/', project)
      .then((response: any) => {
        snackbarService.successMessage('The project has been saved');
        return response;
      })
      .catch((err: any) => snackbarService.errorMessage(err.response.data.messages));
  }

  static updateProject(project: ProjectWithMembers) {
    return axios
      .put('/project-api/projects/', project)
      .then((response: any) => {
        snackbarService.successMessage('The project has been saved');
        return response;
      })
      .catch((err: any) => snackbarService.errorMessage(err.response.data.messages));
  }
}
